import { useState } from 'react';
import { LayoutModule } from '../../../layout/modules';
import { FraudModeFilters } from './filters';
import { FraudModeList } from './list';
import { FRAUD_MODE, FRAUD_MODE_NEW } from '../../../../routes/paths';
import ActionButtonGroup from '../../../components/general/buttons/actionButtonGroup';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { isOnlyViewProfile } from '../../../../shared/types/profiles';
import { Param } from '../../../../shared/types/param';

export const FraudMode = () => {
    const [filters, setFilters] = useState<Param>();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    return (
        <>
            <LayoutModule
                title="Búsqueda de modalidad fraude"
                showTitle
                additionalButtons={
                    <ActionButtonGroup
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: FRAUD_MODE_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: FRAUD_MODE,
                        }}
                    />
                }
            >
                <FraudModeFilters onFilter={(filters) => setFilters(filters)} />
            </LayoutModule>
            <FraudModeList filters={filters} />
        </>
    );
};
